document.querySelector('.menu-items').addEventListener('wheel', function(e) {
    if (e.deltaY > 0) this.scrollLeft += 50;
    else this.scrollLeft -= 50;
    e.preventDefault();
});







// Scroll to top button functionality
var scrollTopBtn = document.getElementById("scrollTopBtn");

window.onscroll = function() {
    scrollFunction();
};

function scrollFunction() {
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        scrollTopBtn.style.display = "block";
    } else {
        scrollTopBtn.style.display = "none";
    }
}

scrollTopBtn.addEventListener('click', function() {
    window.scrollTo({top: 0, behavior: 'smooth'});
});

$(".noOneImage").slick({
    autoplay: true,
    autoplaySpeed: logoSpeed,
    dots: false,
    infinite: true,
    speed: 1000,
    fade: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
  });



$(".topbarSlider").slick({
    autoplay: true,
    autoplaySpeed: topSpeed,
    dots: false,
    infinite: true,
    speed: 1000,
    fade: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
  });

// slick index banner

$(".bannerslider").slick({
    dots: false,
    arrows: true,
    autoplay: true,
    autoplaySpeed: sliderSpeed,
    infinite: true,
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 2,
            autoplay: true,
            autoplaySpeed: sliderSpeed,
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            centerMode: false,
            centerPadding: '40px',
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: sliderSpeed,
          }
        }
      ]
  });

$(function(){
    $('.selectpicker').selectpicker();
});


var slider = $('.secondCategorySlider');

function initializeSlider() {
    slider.slick({
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: bannerspeed,
        infinite: true,
        centerPadding: '60px',
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              centerPadding: '40px',
              slidesToShow: 4
            }
          },
          
        ]
    });
}

// Initialize slider only if window width is above 768px
if ($(window).width() > 767) {
    initializeSlider();
}

$(window).on('resize', function() {
    if ($(window).width() <= 766) {
        if (slider.hasClass('slick-initialized')) {
            slider.slick('unslick');  // Destroy slider on mobile
        }
    } else {
        if (!slider.hasClass('slick-initialized')) {
            initializeSlider();  // Reinitialize slider on larger screens
        }
    }
});




        var sliderProduct = $('.productIndexSlider');

        function initializeSliderProd() {
          sliderProduct.slick({
                dots: false,
                arrows: true,
                infinite: true,
                centerPadding: '60px',
                autoplay: true,
                autoplaySpeed: 2000,
                slidesToShow: 2,
                centerMode: true,
                slidesToScroll: 1,
                responsive: [
                  {
                    breakpoint: 767,
                    settings: {
                      centerPadding: '40px',
                      slidesToShow: 2
                    }
                  },

                  {
                    breakpoint: 480,
                    settings: {
                      centerPadding: '20px',
                      slidesToShow: 2
                    }
                  },
                  
                ]
            });
        }

        // Initialize slider only if window width is above 768px
        if ($(window).width() <= 991) {
          initializeSliderProd();
        }

        $(window).on('resize', function() {
            if ($(window).width() > 991) {
                if (sliderProduct.hasClass('slick-initialized')) {
                  sliderProduct.slick('unslick');  // Destroy slider on mobile
                }
            } else {
                if (!sliderProduct.hasClass('slick-initialized')) {
                  initializeSliderProd();  // Reinitialize slider on larger screens
                }
            }
        });







        var sliderProductFree = $('.productIndexSliderFree');

        function initializeSliderProdFree() {
          sliderProductFree.slick({
                dots: false,
                arrows: true,
                infinite: true,
                centerPadding: '60px',
                autoplay: true,
                autoplaySpeed: 2000,
                slidesToShow: 2,
                centerMode: true,
                slidesToScroll: 1,
                responsive: [
                  {
                    breakpoint: 767,
                    settings: {
                      centerPadding: '40px',
                      slidesToShow: 2
                    }
                  },

                  {
                    breakpoint: 480,
                    settings: {
                      centerPadding: '20px',
                      slidesToShow: 2
                    }
                  },
                  
                ]
            });
        }

        // Initialize slider only if window width is above 768px
        if ($(window).width() <= 991) {
          initializeSliderProdFree();
        }

        $(window).on('resize', function() {
            if ($(window).width() > 991) {
                if (sliderProductFree.hasClass('slick-initialized')) {
                  sliderProductFree.slick('unslick');  // Destroy slider on mobile
                }
            } else {
                if (!sliderProductFree.hasClass('slick-initialized')) {
                  initializeSliderProdFree();  // Reinitialize slider on larger screens
                }
            }
        });









         // Select the category div and dropdown menu
         const categoryToggle = document.getElementById('categoryToggle');
         const dropdownMenu = document.getElementById('dropdownMenu');
 
         // Toggle the dropdown visibility on click
         categoryToggle.addEventListener('click', function() {
             if (dropdownMenu.style.display === 'block') {
                 dropdownMenu.style.display = 'none';
             } else {
                 dropdownMenu.style.display = 'block';
             }
         });
 
         // Close the dropdown if clicking outside of it
         document.addEventListener('click', function(event) {
             if (!dropdownMenu.contains(event.target) && !categoryToggle.contains(event.target)) {
                 dropdownMenu.style.display = 'none';
             }
         });


// document.addEventListener("DOMContentLoaded", function() {
//     document.querySelectorAll('.cartAdd').forEach(function(button) {
//         button.addEventListener('click', function(event) {
//             event.preventDefault();
            
//             // Get elements for cart icon and loader
//             const cartIcon = button.querySelector('.cart-icon');
//             const loader = button.querySelector('.loader');
            
//             // Get the variant ID from data-id attribute
//             const variantId = button.getAttribute('data-id');

//             // Show loader, hide cart icon
//             cartIcon.style.display = 'none';
//             loader.style.display = 'block';

//             // AJAX call to add the item to the cart
//             fetch('/cart/add.js', {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify({
//                     id: variantId,
//                     quantity: 1
//                 })
//             })
//             .then(response => response.json())
//             .then(data => {
//                 console.log("Added to cart:", data);

//                 // Update cart badge
//                 updateCartCount();
//             })
//             .catch(error => {
//                 console.error("Error adding to cart:", error);
//             })
//             .finally(() => {
//                 // Hide loader, show cart icon
//                 loader.style.display = 'none';
//                 cartIcon.style.display = 'block';
//             });
//         });
//     });

//     // Function to update the cart count
//     function updateCartCount() {
//         fetch('/cart.js')
//             .then(response => response.json())
//             .then(cart => {
//                 document.querySelectorAll('.cartAdd .icon-badge .badge').forEach(function(badge) {
//                     badge.textContent = cart.item_count;
//                 });
//             })
//             .catch(error => {
//                 console.error("Error updating cart count:", error);
//             });
//     }
// });



//quantity disable and select code



